import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import {
  UpdateWashingMachinePartForm,
  UpdateWashingMachinePartPageHeader,
} from '@/components/pages/WashingMachinePart/Update'
import { UpdateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/UpdateWashingMachinePartRequest'

import { useGetWashingMachinePart, useUpdateWashingMachinePart } from './Update.hooks'

const UpdateWashingMachinePart = () => {
  const params = useParams<{ id: string }>()
  const { updateWashingMachinePart, loading: updateLoading } = useUpdateWashingMachinePart()

  const {
    getWashingMachinePart,
    loading: getLoading,
    response: getWashingMachinePartResponse,
  } = useGetWashingMachinePart()

  const id = Number(params.id)

  const handleSubmitForm = async (formValues: UpdateWashingMachinePartRequest) => {
    await updateWashingMachinePart({
      ...formValues,
      id,
    })
  }

  useEffect(() => {
    getWashingMachinePart({ id })
  }, [getWashingMachinePart, id])

  return (
    <>
      <UpdateWashingMachinePartPageHeader />
      <UpdateWashingMachinePartForm
        {...{ updateLoading, getLoading, getWashingMachinePartResponse }}
        onSubmit={handleSubmitForm}
      />
    </>
  )
}

UpdateWashingMachinePart.displayName = 'UpdateWashingMachinePart'
export default UpdateWashingMachinePart
